const toastr = require("toastr");
var buttonClicked = false;

const Free = function(){
  var priv = {};
  var pub = {};


  priv.validateSubmit = function(e){
    e.preventDefault();
    e.stopPropagation();

	if (buttonClicked) {
		return false;
	}

	window.showToast([['sucess', 'Aguarde processando']]);
	buttonClicked = true;

	if ($('#transaction_person_attributes_name').val().trim().indexOf(" ") < 0) {
  		toastr.error('Campo nome, deve conter nome e sobrenome!.', 'Erro!');
		  buttonClicked = false;
  		return false;
  	}

	var emailRegex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

	if(!emailRegex.test($('#transaction_person_attributes_email').val().trim())) {
  		toastr.error('Campo email, deve conter um email válido!.', 'Erro!');
		  buttonClicked = false;
  		return false;
  	}


    // $('input#transaction_sender_hash').val(PagSeguroDirectPayment.getSenderHash());
    $('form').unbind('submit').trigger('submit');
    $('form').bind('submit', priv.validateSubmit);

    return false
  }

  pub.init = function(session_id, production){
    $('form').on('submit', priv.validateSubmit);
  }

  return pub;
}()

export default Free;
